import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
  },
  {
    path: '/game',
    name: 'Game',
    component: () => import('../views/Game.vue'),
  },
  {
    path: '/bonus',
    component: () => import('../views/bonus/index.vue'),
  },
  {
    path: '/done',
    component: () => import('../views/bonus/done.vue'),
  },
  {
    path: '/noBonus',
    component: () => import('../views/bonus/no.vue'),
  },
  {
    path: '/realGift',
    component: () => import('../views/bonus/realGift.vue'),
  },
  {
    path: '/log',
    component: () => import('../views/bonus/log.vue'),
  },

  {
    path: '/yu',
    component: () => import('../views/cmp/yu.vue'),
  },

  {
    path: '/result',
    component: () => import('../views/result/index.vue'),
  },

  {
    path: '/rodemap/ssq/01',
    component: () => import('../views/rodemap/ssq/01.vue'),
  },
  {
    path: '/rodemap/ssq/02',
    component: () => import('../views/rodemap/ssq/02.vue'),
  },
  {
    path: '/rodemap/ssq/03',
    component: () => import('../views/rodemap/ssq/03.vue'),
  },
  {
    path: '/rodemap/ssq/04',
    component: () => import('../views/rodemap/ssq/04.vue'),
  },
  {
    path: '/rodemap/ssq/05',
    component: () => import('../views/rodemap/ssq/05.vue'),
  },
  {
    path: '/rodemap/ssq/06',
    component: () => import('../views/rodemap/ssq/06.vue'),
  },
  {
    path: '/rodemap/ssq/06_5',
    component: () => import('../views/rodemap/ssq/06_5.vue'),
  },
  {
    path: '/rodemap/ssq/07',
    component: () => import('../views/rodemap/ssq/07.vue'),
  },
  {
    path: '/rodemap/ssq/07.5',
    component: () => import('../views/rodemap/ssq/07.5.vue'),
  },
  {
    path: '/rodemap/ssq/08',
    component: () => import('../views/rodemap/ssq/08.vue'),
  },

  // 乔诗语

  {
    path: '/rodemap/qsy/01',
    component: () => import('../views/rodemap/qsy/01.vue'),
  },
  {
    path: '/rodemap/qsy/02',
    component: () => import('../views/rodemap/qsy/02.vue'),
  },
  {
    path: '/rodemap/qsy/03',
    component: () => import('../views/rodemap/qsy/03.vue'),
  },
  {
    path: '/rodemap/qsy/04',
    component: () => import('../views/rodemap/qsy/04.vue'),
  },
  {
    path: '/rodemap/qsy/05',
    component: () => import('../views/rodemap/qsy/05.vue'),
  },
  {
    path: '/rodemap/qsy/06',
    component: () => import('../views/rodemap/qsy/06.vue'),
  },
  {
    path: '/rodemap/qsy/06_5',
    component: () => import('../views/rodemap/qsy/06_5.vue'),
  },
  {
    path: '/rodemap/qsy/07',
    component: () => import('../views/rodemap/qsy/07.vue'),
  },
  {
    path: '/rodemap/qsy/08',
    component: () => import('../views/rodemap/qsy/08.vue'),
  },
  {
    path: '/rodemap/qsy/09',
    component: () => import('../views/rodemap/qsy/09.vue'),
  },

  //阿杰
  {
    path: '/rodemap/aj/01',
    component: () => import('../views/rodemap/aj/01.vue'),
  },
  {
    path: '/rodemap/aj/02',
    component: () => import('../views/rodemap/aj/02.vue'),
  },
  {
    path: '/rodemap/aj/03',
    component: () => import('../views/rodemap/aj/03.vue'),
  },
  {
    path: '/rodemap/aj/04',
    component: () => import('../views/rodemap/aj/04.vue'),
  },
  {
    path: '/rodemap/aj/04_5',
    component: () => import('../views/rodemap/aj/04_5.vue'),
  },
  {
    path: '/rodemap/aj/05',
    component: () => import('../views/rodemap/aj/05.vue'),
  },
  {
    path: '/rodemap/aj/06',
    component: () => import('../views/rodemap/aj/06.vue'),
  },
  {
    path: '/rodemap/aj/07',
    component: () => import('../views/rodemap/aj/07.vue'),
  },
  {
    path: '/rodemap/aj/07_5',
    component: () => import('../views/rodemap/aj/07_5.vue'),
  },
  {
    path: '/rodemap/aj/08',
    component: () => import('../views/rodemap/aj/08.vue'),
  },

  // 杨天翔
  {
    path: '/rodemap/ytx/01',
    component: () => import('../views/rodemap/ytx/01.vue'),
  },
  {
    path: '/rodemap/ytx/02',
    component: () => import('../views/rodemap/ytx/02.vue'),
  },
  {
    path: '/rodemap/ytx/03',
    component: () => import('../views/rodemap/ytx/03.vue'),
  },
  {
    path: '/rodemap/ytx/04',
    component: () => import('../views/rodemap/ytx/04.vue'),
  },
  {
    path: '/rodemap/ytx/05',
    component: () => import('../views/rodemap/ytx/05.vue'),
  },
  {
    path: '/rodemap/ytx/06',
    component: () => import('../views/rodemap/ytx/06.vue'),
  },
  {
    path: '/rodemap/ytx/07',
    component: () => import('../views/rodemap/ytx/07.vue'),
  },
  {
    path: '/rodemap/ytx/08',
    component: () => import('../views/rodemap/ytx/08.vue'),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
